import { Container } from '@rxdi/core';
import { css, html, TemplateResult, unsafeCSS } from '@rxdi/lit-html';
import { ModalViewService } from '@shared/services';
import { SteelFabTheme } from '@shared/styles/theme';

export const openConfirmDialog = (title?: string | TemplateResult, description?: string | TemplateResult) => {
  const modalService = Container.get(ModalViewService);

  return modalService.openConfirmDialog({
    template: html`
      <div class="glass-dialog">
        <div
          style="background: var(--bg-primary); padding: 25px; border-radius: 15px;border: 1px solid rgba(0, 0, 0, 0.08);"
        >
          <h2 class="title" style="margin-bottom: 0.5rem">${title || 'Confirm Action'}</h2>
          <p class="description">${description || 'Are you sure you want to proceed with this action?'}</p>
          <div class="actions">
            <button class="btn btn-secondary" @click=${() => modalService.close(false)}>Cancel</button>
            <button class="btn btn-danger" @click=${() => modalService.close(true)}>Confirm</button>
          </div>
        </div>
      </div>
    `,
    style: css`
      ${SteelFabTheme}
      :host {
        font-family: 'Inter', 'Poppins', 'Segoe UI', system-ui, -apple-system, sans-serif;
      }

      @keyframes dialog-desktop-enter {
        from {
          opacity: 0;
          transform: scale(0.95) translateY(-5px);
        }
        to {
          opacity: 1;
          transform: scale(1) translateY(0);
        }
      }

      @keyframes dialog-mobile-enter {
        from {
          transform: translateY(100%);
        }
        to {
          transform: translateY(0);
        }
      }

      .close-button {
        display: none;
      }
      .container {
        padding-top: 10rem !important;
      }

      .dialog {
        padding: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        /* Glass effect base */
        /* background: rgba(12, 11, 28, 0.6) !important; */
        /* backdrop-filter: blur(20px) !important; */
        /* -webkit-backdrop-filter: blur(20px) !important; */
        /* border: 1px solid rgba(255, 255, 255, 0.08) !important; */
        border-radius: 24px !important;
        /* box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5) !important; */

        display: flex !important;
        flex-direction: column;
        overflow: hidden !important;
        min-width: 420px !important;
        max-width: 90vw !important;
        /* transition: opacity 0.1s linear, transform; */

        will-change: transform, opacity !important;
        animation: dialog-desktop-enter 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;
      }

      .glass-dialog {
        padding: 2.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .title {
        margin: 0 0 1rem 0;
        color: #333;
        font-size: 1.5rem;
        font-weight: 700;
        letter-spacing: -0.02em;
        line-height: 1.2;
      }

      .description {
        color: #333;
        margin: 0 0 2.5rem 0;
        font-size: 1.05rem;
        line-height: 1.6;
        max-width: 380px;
      }

      .actions {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 1rem;
      }

      .btn {
        min-width: 120px;
        border-radius: 12px;
        padding: 0.8rem 1.5rem;
        font-weight: 600;
        font-size: 1rem;
        cursor: pointer;
        transition: all 0.2s ease;
      }

      .btn-primary {
        border: none;
        color: white;
        box-shadow: 0 4px 12px rgba(127, 91, 255, 0.3);
      }

      .btn-primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(127, 91, 255, 0.4);
      }

      .btn-secondary {
        background: #333;
        border: 1px solid rgba(0, 0, 0, 0.1);
        color: #fff;
      }

      .btn-secondary:hover {
        background: rgba(0, 0, 0, 0.8);
        border-color: white;
        transform: translateY(-2px);
      }

      .btn-danger {
        border: none;
        color: white;
        box-shadow: 0 4px 12px rgba(255, 75, 75, 0.3);
      }

      .btn-danger:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(255, 75, 75, 0.4);
      }

      @media (max-width: 900px) {
        .dialog {
          min-width: 100% !important;
          width: 100% !important;
          height: 100% !important;
          max-width: none !important;
          border-radius: 0 !important;
          border: none !important;
          margin: 0 !important;
          position: fixed !important;
          inset: 0 !important;
          justify-content: center; /* Center content vertically */
          /* Stronger glass for full screen */
          /* background: rgba(9, 6, 22, 0.85) !important; */
          /* backdrop-filter: blur(30px) !important; */
        }

        .glass-dialog {
          padding: 2rem;
          flex: 1;
          justify-content: center;
        }

        .actions {
          flex-direction: column-reverse; /* Cancel at bottom */
          gap: 1rem;
          width: 100%;
        }

        .btn {
          width: 100%;
          padding: 1rem;
          font-size: 1.1rem;
        }

        .description {
          font-size: 1.1rem;
        }
      }
    `,
  });
};
